import { createApp } from 'vue';

import {
  DatePicker,
  Button,
  Form,
  Input,
  InputNumber,
  Select,
  Spin,
  Carousel,
  Row,
  Col,
  Image,
  Pagination,
  Modal,
  Divider,
  Radio,
  Table,
  Popconfirm,
  ConfigProvider,
  Descriptions,
  Checkbox,
  Tooltip
} from 'ant-design-vue';

import App from './App.vue';
import router from './router';
import i18n from './lang';
import store, { initData } from './store';
import bus, { MittProps } from '@/utils/bus';
// import { BUS_SYMBOL } from '@/utils/symbol';
const app = createApp(App);

// 让this 可以.出$bus
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $bus: MittProps;
  }
}

initData()
  .then()
  .finally(() => {
    app
      .use(i18n)
      .use(store)
      .use(router)
      .use(DatePicker)
      .use(Button)
      .use(Form)
      .use(Radio)
      .use(Input)
      .use(InputNumber)
      .use(Select)
      .use(Carousel)
      .use(Row)
      .use(Col)
      .use(Image)
      .use(Modal)
      .use(Spin)
      .use(Table)
      .use(Pagination)
      .use(Descriptions)
      .use(Checkbox)
      .use(Popconfirm)
      .use(ConfigProvider)
      .use(Tooltip)
      .use(Divider);

    app.config.globalProperties.$bus = bus;

    // app.provide(BUS_SYMBOL, bus);

    app.mount('#app');
  });
